// Thư viện khối REDDIT cho Tự dựng / kịch bản sơ đồ.
// ĐÃ ĐO THẬT (khảo sát của bot, Downloads/ban-do-giao-dien-2026-09-23.json, host www.reddit.com, giao diện "shreddit"):
//   · tìm bài /search/?q=…&sort=new: mỗi kết quả = search-telemetry-tracker > div[data-testid="search-post-unit"]; tiêu đề + liên kết bài =
//     a[data-testid="post-title"] (có khi có aria-label = tiêu đề) và a#search-post-title-t3_<id>[data-testid="post-title-text"] (chữ = tiêu đề);
//     href dạng /r/<cộng đồng>/comments/<id>/<slug>/ (tiếng Việt có dấu trong slug).
//   · trang bài: ô bình luận = comment-composer-host > faceplate-tracker > faceplate-textarea-input[data-testid="trigger-button"][placeholder="Join the conversation"];
//     textarea thật nằm trong SHADOW của faceplate-textarea-input (nấc css của bot dùng deepQueryAll nên xuyên shadow; XPath thì KHÔNG xuyên).
// CHƯA ĐO THẬT (bài được khảo sát có 0 bình luận; nút gửi chỉ hiện SAU khi gõ, khảo sát không gõ): nút gửi "Comment"/"Reply", nút Reply của từng
// bình luận (shreddit-comment). Thang dùng cấu trúc shreddit phổ biến + nấc AI cuối; khi có khảo sát màn bai_co_binh_luan / o_tra_loi_binh_luan /
// o_soan_da_go (src/background/khao-sat.ts) thì đối chiếu và sửa ở đây — tham chiếu bản đồ (Boss) sẽ báo "khảo sát chưa thấy" cho tới lúc đó.
// Quy tắc: KHÔNG có khối nào bấm nút điểm của bài/bình luận (đã từ chối: thao túng điểm số). Reddit phạt nặng quảng cáo ngầm → câu AI soạn phải trả lời đúng chủ đề, không quảng cáo
// lộ liễu, nhắc sản phẩm thì nói rõ mình liên quan. Bước gõ/gửi rủi ro cao (cổng duyệt) + sổ cái; ô gõ vùng "bai" — ô chat Reddit bị loại (L-42).
import type { KhoiMau } from "./tu-dung";
import { SEL_O_DANG_GO } from "./bundle";
import { KHONG_SAN_PHAM, RE_LUAT_CAM_QC } from "./khong-san-pham";

import { kemAnhHoc, TS_KEM_ANH_TAT_CA } from "./kem-anh";
import { themChiBaiLienQuan } from "./chi-lien-quan"; // (05/10) "Chỉ bình luận bài liên quan" co/khong cho mọi khối có bước chấm

export const RD_URL = "https://www.reddit.com/";
// KÈM ẢNH (04/10/2026, src/shared/kem-anh.ts) — Reddit chỉ cho ảnh trong bình luận khi CỘNG ĐỒNG bật. GIẢ ĐỊNH CHƯA ĐO: khi bật, ô soạn đang mở
// (comment-composer-host) có input[type=file] (nút ảnh trên thanh công cụ); không có → bot gửi chỉ chữ / bỏ mục theo khi_loi_anh, ghi lý do.
// Bình luận đăng xong có <img> trong shreddit-comment TRONG CÙNG chứa câu vừa gửi.
const RD_HAU_KIEM_ANH = [{ t: "locator_visible" as const, target: { describe: "ảnh trong bình luận vừa đăng (bình luận chứa câu vừa gửi)", ladder: [
  { t: "xpath" as const, xpath: '(//shreddit-comment[contains(normalize-space(.), {{ xpath_chu(cau_da_go) }})][not(.//shreddit-comment[contains(normalize-space(.), {{ xpath_chu(cau_da_go) }})])]//img)[1]' },
] } }];

export const POST_LIST_SPEC = {
  mode: "list",
  list: { describe: "danh sách bài trong kết quả tìm Reddit", ladder: [
    { t: "css", sel: '[data-testid="search-post-unit"]' },
    { t: "css", sel: "shreddit-post" },
  ] },
  fields: {
    tieu_de: { sel: 'a[data-testid="post-title-text"]', attr: "text", fallback: "longest_text" },
    lien_ket: { sel: 'a[data-testid="post-title-text"], a[data-testid="post-title"]', attr: "href" },
    cong_dong: { sel: 'a[data-testid="post-title-text"], a[data-testid="post-title"]', attr: "href", regex: "/r/([^/]+)/comments/" },
    ma_bai: { sel: 'a[data-testid="post-title-text"], a[data-testid="post-title"]', attr: "href", regex: "/comments/([a-z0-9]+)/" },
  },
  item_key: "lien_ket",
};

// Ô bình luận của BÀI: textarea nằm trong SHADOW của faceplate-textarea-input — CSS "cha con" không nối được qua ranh giới shadow, nên nấc chính là
// "ô ĐANG được focus" (SEL_O_DANG_GO, theo activeElement xuyên shadow) ngay sau cú bấm vào ô 'Join the conversation'; nấc phụ là textarea có đúng chữ mờ đo thật
// (ô của bài đứng trước cây bình luận theo thứ tự tài liệu). Ô chat luôn bị loại (L-42) dù đang focus.
const O_BINH_LUAN_BAI = [
  { t: "css", sel: SEL_O_DANG_GO },
  { t: "css", sel: 'textarea[placeholder="Join the conversation"]' },
  { t: "model", prompt: "ô nhập bình luận cho BÀI đang mở ('Join the conversation') — KHÔNG phải ô trả lời dưới một bình luận, KHÔNG phải ô chat/tin nhắn" },
];

// Bình luận chứa chữ đã cho — lấy bình luận TRONG CÙNG (bình luận cha cũng "chứa" chữ của bình luận con lồng bên trong).
const RD_BL = "//shreddit-comment[contains(normalize-space(.), {{ xpath_chu(chu_binh_luan) }})][not(.//shreddit-comment[contains(normalize-space(.), {{ xpath_chu(chu_binh_luan) }})])]";

const RD_BINH_LUAN_ACTIONS = [
  { kind: "navigate", url: "{{bai_url}}" },
  { kind: "click", target: { describe: "ô 'Join the conversation' để mở ô bình luận của bài", ladder: [
    { t: "css", sel: 'comment-composer-host faceplate-textarea-input[data-testid="trigger-button"]' },
    { t: "css", sel: 'faceplate-textarea-input[placeholder="Join the conversation"]' },
    { t: "model", prompt: "ô 'Join the conversation' / 'Tham gia thảo luận' của bài đang mở (không phải ô chat)" },
  ] } },
  { kind: "type", target: { describe: "ô bình luận của bài (textarea trong comment-composer-host)", vung: "bai", ladder: O_BINH_LUAN_BAI }, text: "{{binh_luan}}" },
  // CHƯA ĐO THẬT: nút gửi chỉ hiện sau khi có chữ.
  { kind: "click", target: { describe: "nút Comment (gửi bình luận) của ô bình luận bài", ladder: [
    { t: "css", sel: 'comment-composer-host#top button[type="submit"]' },
    { t: "css", sel: 'comment-composer-host button[slot="submit-button"]' },
    { t: "css", sel: 'comment-composer-host button[type="submit"]' },
    { t: "model", prompt: "nút 'Comment' / 'Bình luận' để gửi bình luận vừa gõ vào ô bình luận của BÀI (không phải nút Reply của một bình luận)" },
  ] } },
];

const RD_TRA_LOI_ACTIONS = [
  { kind: "navigate", url: "{{bai_url}}" },
  // CHƯA ĐO THẬT: nút Reply của bình luận.
  { kind: "click", target: { describe: "nút Reply của bình luận chứa chữ đã cho", ladder: [
    { t: "xpath", xpath: `(${RD_BL}//button[normalize-space(.)="Reply" or normalize-space(.)="Trả lời" or @aria-label="Reply" or @aria-label="Trả lời"])[1]` },
    { t: "model", prompt: "nút 'Reply' / 'Trả lời' NGAY DƯỚI bình luận có chữ {{chu_binh_luan}} (không phải của bình luận khác)" },
  ] } },
  // Ô trả lời vừa mở nằm trong shadow → nấc chính là "ô đang focus" ngay sau cú bấm Reply (không có nấc chữ mờ: sẽ trúng ô bình luận của bài).
  { kind: "type", target: { describe: "ô trả lời vừa mở dưới bình luận đó", vung: "bai", ladder: [
    { t: "css", sel: SEL_O_DANG_GO },
    { t: "model", prompt: "ô nhập trả lời vừa mở ngay dưới bình luận có chữ {{chu_binh_luan}} — KHÔNG phải ô bình luận của bài, KHÔNG phải ô chat" },
  ] }, text: "{{cau_tra_loi}}" },
  { kind: "click", target: { describe: "nút Reply (gửi) của ô trả lời đó", ladder: [
    { t: "css", sel: 'shreddit-comment comment-composer-host button[slot="submit-button"]' },
    { t: "css", sel: 'shreddit-comment comment-composer-host button[type="submit"]' },
    { t: "model", prompt: "nút gửi ('Reply'/'Comment') của ô trả lời vừa gõ dưới bình luận có chữ {{chu_binh_luan}}" },
  ] } },
];

export const KHONG_QC = "Viết tự nhiên như một thành viên cộng đồng: trả lời đúng điều bài/bình luận đang hỏi, có ích trước đã; không quảng cáo lộ liễu, không chèn liên kết; nếu nhắc tới sản phẩm của mình thì phải nói rõ mình là người làm/dùng sản phẩm đó.";

// ===================== Reddit — TÌM RỒI BÌNH LUẬN (2026-10-03) =====================
// Luồng: tìm bài MỚI theo từ khoá (cùng trang + danh sách đo thật của tim_bai) → đọc nick đang đăng nhập (menu người dùng) → lọc bài đã bình luận
// (sổ cái) → [có sản phẩm/mục tiêu: AI chấm liên quan — chamPhuHop] → mở TỪNG bài đọc trước: bài đã khoá / lưu trữ (không còn ô bình luận), bài
// của chính nick, bài nick đã bình luận → BỎ (lý do rõ trong nhật ký); cộng đồng có luật cấm quảng cáo / tự quảng bá → câu soạn KHÔNG nhắc sản
// phẩm (generate.guide KHONG_SAN_PHAM — src/shared/khong-san-pham.ts: không đưa hồ sơ sản phẩm cho AI + chặn tất định câu có tên sản phẩm)
// → gửi vào ô 'Join the conversation' của bài (rủi ro cao, có duyệt, sổ cái). Lúc gửi (chạy thật) còn chốt lại trên trang: bài khoá / của mình /
// đã có bình luận của nick → bỏ (bo_qua_khi).
// ĐÃ ĐO THẬT: kết quả tìm (search-post-unit), ô 'Join the conversation' (comment-composer-host faceplate-textarea-input), main#main-content.
// Khảo sát thật 04/10 (Reddit CHƯA đăng nhập): nút #expand-user-drawer-button có thật (bai #5); liên kết tác giả bài a[aria-label="Author: <tên>"]
// href /user/<tên>/ trong shreddit-post (bai_luu_tru #14). Khảo sát không ghi thuộc tính author/locked/archived và không thấy chữ "Archived post" trong
// phần tử có vai trò; bài top 5 năm (bai_luu_tru) VẪN có ô 'Join the conversation' (#27) → không dựa vào việc thiếu ô bình luận để nhận bài khoá.
// GIẢ ĐỊNH CHƯA ĐO: liên kết /user/<nick>/ trong #user-drawer-content (cần đăng nhập); thuộc tính author của
// shreddit-post / shreddit-comment; chữ "Archived post" / "Locked post" / "New comments cannot be posted" (và thuộc tính locked/archived) của bài
// khoá; khối luật cộng đồng ở thanh bên (#right-sidebar-container / aside); nút gửi Comment (như binh_luan_mot_bai); bình luận vừa gửi hiện
// thành shreddit-comment.
export const RD_NICK_SPEC = { mode: "single", target: { describe: "tên nick Reddit đang đăng nhập trong menu người dùng (liên kết /user/<nick>/) — không có = chưa đăng nhập / trang đăng nhập / CAPTCHA → dừng", ladder: [
  { t: "xpath", xpath: '(//*[@id="user-drawer-content"]//a[contains(@href, "/user/")])[1]' },
  { t: "css", sel: '#user-drawer-content a[href*="/user/"]' },
] }, attr: "href", regex: "/user/([A-Za-z0-9_-]+)" };
const RD_KHOA_CHU = "Archived post|Locked post|New comments cannot be posted|Bài viết đã được lưu trữ|Bài viết đã bị khoá|Bài viết đã bị khóa|Không thể đăng bình luận mới";
export const RD_KIEM_BAI_SPEC = {
  mode: "list",
  list: { describe: "trang bài Reddit đang mở (một mục: cả trang)", ladder: [{ t: "css", sel: "body" }] },
  fields: {
    tac_gia: { sel: "shreddit-post", attr: "author" },
    khoa: { sel: "#main-content, main", attr: "text", phan_loai: [{ re: RD_KHOA_CHU, gt: "khoa" }], mac_dinh: "" },
    khoa_tt: { sel: "shreddit-post[locked], shreddit-post[archived], shreddit-post[is-locked], shreddit-post[is-archived]", attr: "html", phan_loai: [{ re: "[\\s\\S]*", gt: "khoa" }], mac_dinh: "" },
    o_bl: { sel: "comment-composer-host faceplate-textarea-input", attr: "placeholder", phan_loai: [{ re: "[\\s\\S]*", gt: "co" }], mac_dinh: "" },
    da_bl: { sel: 'shreddit-comment[author="{{nick_rd}}" i]', attr: "author", phan_loai: [{ re: "[\\s\\S]*", gt: "co" }], mac_dinh: "" },
    cam_qc: { sel: '#right-sidebar-container, aside, [slot="sidebar"]', attr: "text", phan_loai: [{ re: RE_LUAT_CAM_QC, gt: "cam_qc" }], mac_dinh: "" },
    noi_dung: { sel: "shreddit-post", attr: "text", regex: "^([\\s\\S]{0,600})" },
  },
};
const RD_GUI_BL_ACTIONS = RD_BINH_LUAN_ACTIONS.map((a, i) => (i === 0 ? { kind: "navigate", url: "{{item.lien_ket}}" } : a.kind === "type" ? { ...a, text: "{{item.binh_luan}}" } : a));
const RD_DA_GUI_BL = [
  { t: "url_contains", s: "{{item.ma_bai}}" },
  { t: "text_visible", text: "{{item.binh_luan}}" },
  { t: "locator_visible", target: { describe: "bình luận vừa gửi hiện trong cây bình luận của bài", ladder: [
    { t: "xpath", xpath: "(//shreddit-comment[contains(normalize-space(.), {{ xpath_chu(item.binh_luan) }})])[1]" },
  ] } },
];
const RD_BO_QUA_GUI = [
  { khi: { t: "text_visible", text: "Archived post" }, ghi: "bài đã lưu trữ (Archived) — không bình luận được" },
  { khi: { t: "text_visible", text: "Locked post" }, ghi: "bài đã khoá bình luận (Locked) — không bình luận được" },
  { khi: { t: "dom_exists", sel: 'shreddit-post[author="{{nick_rd}}" i]' }, ghi: "bài của chính nick u/{{nick_rd}} — không tự bình luận bài mình" },
  { khi: { t: "dom_exists", sel: 'shreddit-comment[author="{{nick_rd}}" i]' }, ghi: "nick u/{{nick_rd}} đã bình luận bài này từ trước — không bình luận lại" },
];

// ===================== BÌNH LUẬN MỘT BÀI — ĐỂ TRỐNG ĐỊA CHỈ → TỰ TÌM BÀI (05/10/2026, src/shared/tu-dung.ts BienTheTuTim) =====================
// Đúng luồng của tim_roi_binh_luan (tìm bài MỚI theo từ khoá → đọc nick → bỏ bài đã bình luận → [AI chấm liên quan] → mở đọc trước: bỏ bài khoá/lưu trữ,
// bài của chính nick, bài nick đã bình luận → cộng đồng cấm quảng cáo thì câu không nhắc sản phẩm → gửi), từ khoá máy điền lúc lắp (bước Tìm / sản phẩm /
// mục tiêu), bình luận ĐÚNG MỘT bài (đọc trước tối đa 3 bài để còn bài thay khi bài đầu bị khoá). Id bước riêng (ghép được với tim_roi_binh_luan); sổ cái
// da_binh_luan_rd dùng chung → hai khối không bình luận trùng bài.
const RD_DK_TU_TIM = "len(trim(tk_bai_rd)) > 0";
const RD_TU_TIM_BINH_LUAN = {
  thamSo: "bai_url", chung: "rd_bai",
  yamlTim: `  - id: tk_bai_rd
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_bai_rd

  - id: tim_bai_rd_tu_tim
    when: "${RD_DK_TU_TIM}"
    on: web
    do: "tìm bài Reddit mới nhất theo từ khoá {{tk_bai_rd}}"
    expect: "url chứa /search"

  - id: mo_menu_nick_rd_tu_tim
    when: "${RD_DK_TU_TIM}"
    on: web
    do: "bấm nút menu người dùng (góc trên phải) để xem nick đang dùng"
    expect: "menu người dùng mở"
    timeout: 20s

  - id: lay_nick_rd_tu_tim
    when: "${RD_DK_TU_TIM}"
    on: web
    extract: "nick Reddit đang đăng nhập (menu người dùng)"
    into: nick_rd
    timeout: 10s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: dong_menu_nick_rd_tu_tim
    when: "${RD_DK_TU_TIM}"
    on: web
    do: "đóng menu người dùng (phím Esc)"
    optional: true

  - id: lay_bai_rd_tu_tim
    when: "${RD_DK_TU_TIM}"
    on: web
    extract: "bài kết quả tìm Reddit: tieu_de, lien_ket, cong_dong, ma_bai"
    into: ds_bai_rd

  - id: loc_bai_rd_tu_tim
    when: "${RD_DK_TU_TIM}"
    filter: "len(nick_rd) > 1 and len(str(item.lien_ket)) > 0"
    into: ds_bai_rd`,
  yamlSteps: `  - id: chon_bai_rd_tu_tim
    when: "${RD_DK_TU_TIM}"
    filter: "item.lien_ket not in ledger.da_binh_luan_rd"
    into: ds_bai_rd

  - id: kiem_bai_rd_tu_tim
    for_each: ds_bai_rd
    max_items: 3
    when: "${RD_DK_TU_TIM}"
    on_item_error: skip
    steps:
      - id: mo_bai_rd_tu_tim
        on: web
        do: "mở bài {{item.lien_ket}} để đọc trước khi bình luận"
        expect: "trang bài Reddit"
        timeout: 30s
      - id: doc_bai_rd_tu_tim
        on: web
        extract: "trang bài: tac_gia, khoa, khoa_tt, o_bl, da_bl, cam_qc, noi_dung"
        into: item.kiem
        timeout: 8s
      - id: bo_bai_khoa_rd_tu_tim
        when: "not item._bo_qua and (item.kiem[0].khoa or item.kiem[0].khoa_tt or not item.kiem[0].o_bl)"
        template: "bài đã khoá hoặc đã lưu trữ (không còn ô bình luận) — không bình luận"
        into: item._bo_qua
      - id: bo_bai_cua_minh_rd_tu_tim
        when: "not item._bo_qua and lower(str(item.kiem[0].tac_gia)) == lower(nick_rd)"
        template: "bài của chính nick u/{{nick_rd}} — không tự bình luận bài mình"
        into: item._bo_qua
      - id: bo_bai_da_bl_rd_tu_tim
        when: "not item._bo_qua and item.kiem[0].da_bl"
        template: "nick u/{{nick_rd}} đã bình luận bài này từ trước — không bình luận lại"
        into: item._bo_qua

  - id: soan_bai_rd_tu_tim
    for_each: ds_bai_rd
    max_items: 1
    when: "len(item.kiem) > 0 and not item.kiem[0].cam_qc"
    generate:
      input: "Bài Reddit trong r/{{ str(item.cong_dong) }}: {{ str(item.tieu_de) }} — {{ str(item.kiem[0].noi_dung) }} — Viết MỘT bình luận cho bài này với góc nhìn: {{goc_nhin}}. ${KHONG_QC}"
      guide: knowledge
      max_words: 80
    into: item.binh_luan

  - id: soan_bai_rd_khong_qc_tu_tim
    for_each: ds_bai_rd
    max_items: 1
    when: "len(item.kiem) > 0 and item.kiem[0].cam_qc"
    generate:
      input: "Bài Reddit trong r/{{ str(item.cong_dong) }}: {{ str(item.tieu_de) }} — {{ str(item.kiem[0].noi_dung) }} — Viết MỘT bình luận cho bài này như một thành viên cộng đồng: trả lời đúng điều bài hỏi, có ích; KHÔNG nhắc sản phẩm, dịch vụ, thương hiệu hay liên kết nào (cộng đồng cấm quảng cáo / tự quảng bá)."
      guide: "${KHONG_SAN_PHAM} Cộng đồng r/{{ str(item.cong_dong) }} có luật cấm quảng cáo / tự quảng bá: TUYỆT ĐỐI không nhắc, không ám chỉ sản phẩm, dịch vụ, thương hiệu hay liên kết nào của mình — chỉ chia sẻ kinh nghiệm, trả lời đúng điều bài hỏi."
      max_words: 80
    into: item.binh_luan

  - id: gui_bai_rd_tu_tim
    for_each: ds_bai_rd
    max_items: 1
    when: "len(str(item.binh_luan)) > 0"
    on: web
    do: "mở {{item.lien_ket}}, bấm ô Join the conversation, gõ {{item.binh_luan}} rồi bấm Comment"
    expect: "thấy chữ '{{item.binh_luan}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_binh_luan_rd`,
  learned: {
    tim_bai_rd_tu_tim: { actions: [{ kind: "navigate", url: "{{goc}}search/?q={{ts_url.tu_khoa_tu_tim}}&sort=new" }], postcondition: [{ t: "url_contains", s: "/search" }] },
    mo_menu_nick_rd_tu_tim: { actions: [{ kind: "click", target: { describe: "nút menu người dùng / ảnh đại diện (góc trên phải) — chưa đăng nhập Reddit thì không có nút này", ladder: [
      { t: "css", sel: "#expand-user-drawer-button" },
      { t: "css", sel: 'button[aria-label="Expand user menu"]' },
    ] } }], postcondition: [{ t: "dom_exists", sel: "#user-drawer-content" }] },
    lay_nick_rd_tu_tim: { extract_spec: RD_NICK_SPEC },
    dong_menu_nick_rd_tu_tim: { actions: [{ kind: "press", key: "Escape" }] },
    lay_bai_rd_tu_tim: { extract_spec: POST_LIST_SPEC, ghi_khi_rong: "không tìm thấy bài nào theo từ khoá — không có gì để làm" },
    loc_bai_rd_tu_tim: { ly_do_bo: "bài không có liên kết" },
    chon_bai_rd_tu_tim: { ly_do_bo: "nick đã bình luận bài này ở lần chạy trước (sổ cái)" },
    kiem_bai_rd_tu_tim: { con: {
      mo_bai_rd_tu_tim: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }], postcondition: [{ t: "url_contains", s: "{{item.ma_bai}}" }, { t: "dom_exists", sel: "shreddit-post" }] },
      doc_bai_rd_tu_tim: { extract_spec: RD_KIEM_BAI_SPEC },
    } },
    gui_bai_rd_tu_tim: { actions: RD_GUI_BL_ACTIONS, postcondition: RD_DA_GUI_BL, bo_qua_khi: RD_BO_QUA_GUI, kem_anh: kemAnhHoc(2, RD_HAU_KIEM_ANH, { ngu_canh: "{{ str(item.tieu_de) }}" }) },
  },
  params: { goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" } },
  chamPhuHop: { danhSach: "ds_bai_rd", truong: "tieu_de", truocBuoc: "kiem_bai_rd_tu_tim", maxItemsTu: "__mot_muc" },
};

export const KHOI_REDDIT: KhoiMau[] = themChiBaiLienQuan([
  {
    ten: "tim_bai",
    moTa: "Tìm bài Reddit mới nhất theo từ khoá rồi lấy danh sách (tieu_de, lien_ket, cong_dong, ma_bai) vào biến ds_bai",
    thamSo: [{ ten: "tu_khoa", moTa: "từ khoá tìm bài, tiếng Việt có dấu được; nhiều từ khoá cách nhau bằng dấu |; mỗi lần chạy dùng một từ khoá", kieu: "chuoi", batBuoc: true }],
    params: { tu_khoa: { type: "string", default: "{{ts.tu_khoa}}", label: "Từ khoá tìm bài" } },
    trangThu: "https://www.reddit.com/search/?q=trang%20tr%C3%AD%20nh%C3%A0&sort=new",
    yamlSteps: `  - id: tim_bai
    on: web
    do: "tìm bài Reddit mới nhất theo từ khoá {{tu_khoa}}"
    expect: "url chứa /search"

  - id: lay_bai
    on: web
    extract: "bài kết quả tìm Reddit: tieu_de, lien_ket, cong_dong, ma_bai"
    into: ds_bai
    min_items: 1`,
    learned: {
      tim_bai: { actions: [{ kind: "navigate", url: "{{goc}}search/?q={{tu_khoa}}&sort=new" }] },
      lay_bai: { extract_spec: POST_LIST_SPEC },
    },
  },
  {
    ten: "doc_bai",
    moTa: "Đọc lần lượt các bài tìm được như người: mở từng bài và dừng đọc vài giây (chỉ đọc — không bấm, không gõ gì). Dùng sau tim_bai.",
    thamSo: [
      { ten: "so_bai_doc", moTa: "số bài mở đọc tối đa (1-10)", kieu: "so", batBuoc: true, min: 1, max: 10 },
      { ten: "giay_doc", moTa: "số giây dừng đọc mỗi bài (2-60)", kieu: "so", min: 2, max: 60, macDinh: "8" },
    ],
    yamlSteps: `  - id: doc_bai_tim
    for_each: ds_bai
    max_items: {{ts.so_bai_doc}}
    on_item_error: skip
    steps:
      - id: mo_bai_doc
        on: web
        do: "mở bài {{item.lien_ket}} để đọc"
        timeout: 30s
      - id: dung_doc
        wait: {{ts.giay_doc}}`,
    learned: {
      doc_bai_tim: { con: { mo_bai_doc: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }] } } },
    },
  },
  {
    ten: "binh_luan_mot_bai",
    moTa: "Bình luận vào MỘT bài Reddit: có địa chỉ (bai_url) → đúng bài đó; ĐỂ TRỐNG → bot TỰ TÌM một bài MỚI theo từ khoá của kịch bản (bước Tìm / sản phẩm / mục tiêu) như 'Tìm bài rồi bình luận' (bỏ bài khoá/lưu trữ, bài của chính nick, bài đã bình luận; có sản phẩm/mục tiêu thì AI chấm liên quan; cộng đồng cấm quảng cáo thì câu không nhắc sản phẩm); không có bài hợp → không làm gì. AI soạn câu đúng chủ đề (không quảng cáo lộ liễu), gõ vào ô 'Join the conversation' rồi bấm Comment. Rủi ro cao — có cổng duyệt, sổ cái chặn bình luận lần hai.",
    thamSo: [
      { ten: "bai_url", moTa: "địa chỉ bài (https://www.reddit.com/r/<cộng đồng>/comments/<id>/…) — Không bắt buộc — để trống thì bot tự tìm bài phù hợp theo từ khoá (bài mới của bước Tìm / sản phẩm / mục tiêu)", kieu: "chuoi", batBuoc: false },
      { ten: "goc_nhin", moTa: "góc nhìn/kinh nghiệm của nick này (để câu tự nhiên, không trùng nick khác)", kieu: "chuoi", batBuoc: false },
      ...TS_KEM_ANH_TAT_CA,
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ bài" }, goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" } },
    yamlSteps: `  - id: soan
    generate:
      input: "Viết một bình luận cho bài Reddit này với góc nhìn: {{goc_nhin}}. ${KHONG_QC}"
      guide: knowledge
      max_words: 80
    into: binh_luan

  - id: dang_binh_luan
    on: web
    do: "mở {{bai_url}}, bấm ô Join the conversation, gõ {{binh_luan}} rồi bấm Comment"
    expect: "thấy chữ '{{binh_luan}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_binh_luan`,
    learned: { dang_binh_luan: { actions: RD_BINH_LUAN_ACTIONS, kem_anh: kemAnhHoc(2, RD_HAU_KIEM_ANH, { ngu_canh: "{{goc_nhin}}" }) } },
    tuTim: RD_TU_TIM_BINH_LUAN,
  },
  {
    ten: "tra_loi_mot_binh_luan",
    moTa: "Trả lời ĐÚNG một bình luận trên một bài Reddit (tìm bình luận theo chữ nó chứa, lấy bình luận trong cùng): AI soạn câu đúng chủ đề, bấm Reply của bình luận đó, gõ rồi gửi. Rủi ro cao — có cổng duyệt.",
    thamSo: [
      { ten: "bai_url", moTa: "địa chỉ bài chứa bình luận", kieu: "chuoi", batBuoc: true },
      { ten: "chu_binh_luan", moTa: "một đoạn chữ có trong bình luận cần trả lời", kieu: "chuoi", batBuoc: true },
      ...TS_KEM_ANH_TAT_CA,
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ bài" }, chu_binh_luan: { type: "string", default: "{{ts.chu_binh_luan}}", label: "Chữ trong bình luận" } },
    yamlSteps: `  - id: soan_tra_loi
    generate:
      input: "Trả lời bình luận Reddit này: {{chu_binh_luan}}. ${KHONG_QC}"
      guide: knowledge
      max_words: 60
    into: cau_tra_loi

  - id: gui_tra_loi
    on: web
    do: "mở {{bai_url}}, bấm Reply dưới bình luận có chữ {{chu_binh_luan}}, gõ {{cau_tra_loi}} rồi gửi"
    expect: "thấy chữ '{{cau_tra_loi}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_tra_loi_bl`,
    learned: { gui_tra_loi: { actions: RD_TRA_LOI_ACTIONS, kem_anh: kemAnhHoc(2, RD_HAU_KIEM_ANH, { ngu_canh: "{{chu_binh_luan}}" }) } },
  },
  {
    ten: "nghi",
    moTa: "Nghỉ một lúc như người thật, không làm gì trên trang — đặt GIỮA hai việc.",
    thamSo: [{ ten: "giay_nghi", moTa: "số giây nghỉ (5-1800)", kieu: "so", min: 5, max: 1800, macDinh: "60" }],
    yamlSteps: `  - id: nghi
    wait: {{ts.giay_nghi}}`,
    learned: {},
  },
  // ---------- 2026-10-03: tìm bài mới rồi bình luận ----------
  {
    ten: "tim_roi_binh_luan",
    moTa: "Tìm bài Reddit MỚI theo từ khoá rồi bình luận tối đa so_bai bài: máy đọc nick đang đăng nhập, bỏ bài đã bình luận (sổ cái), mở từng bài đọc trước — bỏ bài đã khoá/lưu trữ, bài của chính nick, bài nick đã bình luận; AI soạn bình luận đúng chủ đề theo giọng điệu/cấm kỵ (cộng đồng có luật cấm quảng cáo / tự quảng bá thì câu KHÔNG nhắc sản phẩm); gõ vào ô 'Join the conversation' rồi bấm Comment. Rủi ro cao — có cổng duyệt.",
    thamSo: [
      { ten: "tu_khoa", moTa: "từ khoá tìm bài, tiếng Việt có dấu được; nhiều từ khoá cách nhau bằng dấu |; mỗi lần chạy dùng một từ khoá", kieu: "chuoi", batBuoc: true },
      { ten: "so_bai", moTa: "số bài tối đa sẽ bình luận trong một lần chạy (1-5)", kieu: "so", batBuoc: true, min: 1, max: 5 },
      ...TS_KEM_ANH_TAT_CA,
    ],
    // Từ khoá vào địa chỉ tìm ĐÃ MÃ HOÁ lúc lắp ({{ts_url.tu_khoa}} — "&", "#", "+" không làm gãy địa chỉ); không có tham số chạy riêng.
    chamPhuHop: { danhSach: "ds_bai_bl", truong: "tieu_de", truocBuoc: "kiem_bai_bl", maxItemsTu: "so_bai" },
    yamlSteps: `  - id: tim_bai_bl
    on: web
    do: "tìm bài Reddit mới nhất theo từ khoá {{ts.tu_khoa}}"
    expect: "url chứa /search"

  - id: mo_menu_nick_rd
    on: web
    do: "bấm nút menu người dùng (góc trên phải) để xem nick đang dùng"
    expect: "menu người dùng mở"
    timeout: 20s

  - id: lay_nick_rd
    on: web
    extract: "nick Reddit đang đăng nhập (menu người dùng)"
    into: nick_rd
    timeout: 10s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: dong_menu_nick_rd
    on: web
    do: "đóng menu người dùng (phím Esc)"
    optional: true

  - id: lay_bai_bl
    on: web
    extract: "bài kết quả tìm Reddit: tieu_de, lien_ket, cong_dong, ma_bai"
    into: ds_bai_bl
    min_items: 1

  - id: chon_bai_bl
    filter: "len(nick_rd) > 1 and len(str(item.lien_ket)) > 0 and item.lien_ket not in ledger.da_binh_luan_rd"
    into: ds_bai_bl

  - id: kiem_bai_bl
    for_each: ds_bai_bl
    max_items: {{ts.so_bai}}
    on_item_error: skip
    steps:
      - id: mo_bai_bl
        on: web
        do: "mở bài {{item.lien_ket}} để đọc trước khi bình luận"
        expect: "trang bài Reddit"
        timeout: 30s
      - id: doc_bai_bl
        on: web
        extract: "trang bài: tac_gia, khoa, khoa_tt, o_bl, da_bl, cam_qc, noi_dung"
        into: item.kiem
        timeout: 8s
      - id: bo_bai_khoa_bl
        when: "not item._bo_qua and (item.kiem[0].khoa or item.kiem[0].khoa_tt or not item.kiem[0].o_bl)"
        template: "bài đã khoá hoặc đã lưu trữ (không còn ô bình luận) — không bình luận"
        into: item._bo_qua
      - id: bo_bai_cua_minh_bl
        when: "not item._bo_qua and lower(str(item.kiem[0].tac_gia)) == lower(nick_rd)"
        template: "bài của chính nick u/{{nick_rd}} — không tự bình luận bài mình"
        into: item._bo_qua
      - id: bo_bai_da_bl
        when: "not item._bo_qua and item.kiem[0].da_bl"
        template: "nick u/{{nick_rd}} đã bình luận bài này từ trước — không bình luận lại"
        into: item._bo_qua

  - id: soan_bl_rd
    for_each: ds_bai_bl
    max_items: {{ts.so_bai}}
    when: "len(item.kiem) > 0 and not item.kiem[0].cam_qc"
    generate:
      input: "Bài Reddit trong r/{{ str(item.cong_dong) }}: {{ str(item.tieu_de) }} — {{ str(item.kiem[0].noi_dung) }} — Viết MỘT bình luận cho bài này. ${KHONG_QC}"
      guide: knowledge
      max_words: 80
    into: item.binh_luan

  - id: soan_bl_rd_khong_qc
    for_each: ds_bai_bl
    max_items: {{ts.so_bai}}
    when: "len(item.kiem) > 0 and item.kiem[0].cam_qc"
    generate:
      input: "Bài Reddit trong r/{{ str(item.cong_dong) }}: {{ str(item.tieu_de) }} — {{ str(item.kiem[0].noi_dung) }} — Viết MỘT bình luận cho bài này như một thành viên cộng đồng: trả lời đúng điều bài hỏi, có ích; KHÔNG nhắc sản phẩm, dịch vụ, thương hiệu hay liên kết nào (cộng đồng cấm quảng cáo / tự quảng bá)."
      guide: "${KHONG_SAN_PHAM} Cộng đồng r/{{ str(item.cong_dong) }} có luật cấm quảng cáo / tự quảng bá: TUYỆT ĐỐI không nhắc, không ám chỉ sản phẩm, dịch vụ, thương hiệu hay liên kết nào của mình — chỉ chia sẻ kinh nghiệm, trả lời đúng điều bài hỏi."
      max_words: 80
    into: item.binh_luan

  - id: gui_bl_rd
    for_each: ds_bai_bl
    max_items: {{ts.so_bai}}
    when: "len(str(item.binh_luan)) > 0"
    on: web
    do: "mở {{item.lien_ket}}, bấm ô Join the conversation, gõ {{item.binh_luan}} rồi bấm Comment"
    expect: "thấy chữ '{{item.binh_luan}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_binh_luan_rd`,
    learned: {
      tim_bai_bl: { actions: [{ kind: "navigate", url: "{{goc}}search/?q={{ts_url.tu_khoa}}&sort=new" }], postcondition: [{ t: "url_contains", s: "/search" }] },
      mo_menu_nick_rd: { actions: [{ kind: "click", target: { describe: "nút menu người dùng / ảnh đại diện (góc trên phải) — chưa đăng nhập Reddit thì không có nút này", ladder: [
        { t: "css", sel: "#expand-user-drawer-button" },
        { t: "css", sel: 'button[aria-label="Expand user menu"]' },
      ] } }], postcondition: [{ t: "dom_exists", sel: "#user-drawer-content" }] },
      lay_nick_rd: { extract_spec: RD_NICK_SPEC },
      dong_menu_nick_rd: { actions: [{ kind: "press", key: "Escape" }] },
      lay_bai_bl: { extract_spec: POST_LIST_SPEC },
      kiem_bai_bl: { con: {
        mo_bai_bl: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }], postcondition: [{ t: "url_contains", s: "{{item.ma_bai}}" }, { t: "dom_exists", sel: "shreddit-post" }] },
        doc_bai_bl: { extract_spec: RD_KIEM_BAI_SPEC },
      } },
      gui_bl_rd: { actions: RD_GUI_BL_ACTIONS, postcondition: RD_DA_GUI_BL, bo_qua_khi: RD_BO_QUA_GUI, kem_anh: kemAnhHoc(2, RD_HAU_KIEM_ANH, { ngu_canh: "{{ str(item.tieu_de) }}" }) },
    },
  },
]);
